export type BuyerIncentiveName =
    | 'authenticityGuarantee'
    | 'moneyBackGuarantee'
    | 'cancelationPolicy'
    | 'vettedSellers'
    | 'priceMatch'
    | 'globalDelivery';

export const useBuyerIncentivesList = ({
    useAll = false,
}: {
    useAll?: boolean;
} = {}): BuyerIncentiveName[] => {
    const coreIncentives: BuyerIncentiveName[] = [
        'authenticityGuarantee',
        'moneyBackGuarantee',
        'cancelationPolicy',
    ];

    if (!useAll) {
        return coreIncentives;
    }

    return [...coreIncentives, 'vettedSellers', 'priceMatch', 'globalDelivery'];
};
